import type { FC } from 'react';
import { Alert, alpha, Box, Slide, Typography, useTheme, WifiOffIcon } from '@/shared/ui/mui';
import { useNetworkStatus } from '@/shared/hooks/useNetworkStatus';

/**
 * Persistent banner that displays when user is offline
 * Shows at top of viewport, non-dismissible
 * Auto-hides when connection restored
 */
export const OfflineIndicator: FC = () => {
  const theme = useTheme();
  const { isOnline } = useNetworkStatus();

  return (
    <Slide direction="down" in={!isOnline} mountOnEnter unmountOnExit>
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 9998, // Below modal/dialog (9999) but above everything else
          width: '100%',
        }}
      >
        <Alert
          severity="warning"
          icon={<WifiOffIcon />}
          sx={{
            borderRadius: 0,
            boxShadow: `0 2px 8px ${alpha(theme.palette.common.black, 0.15)}`,
            justifyContent: 'center',
            '& .MuiAlert-icon': {
              alignItems: 'center',
            },
          }}
        >
          <Box>
            <Typography variant="body2" fontWeight="600">
              You&apos;re offline
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Connect to Wi-Fi or cellular data to use all features
            </Typography>
          </Box>
        </Alert>
      </Box>
    </Slide>
  );
};
